import Vue from 'vue';
import Fragment from 'vue-fragment';

import store from './Store/index';
import './Globals/index';

import {plugin as DndsPlugin} from "dnx-design";

export default (rootComponent, selector, localRegisteredComponents) => {
    //Remove after Vue3 upgrade
    //syntax should be the same
    Vue.use(Fragment.Plugin);
    
    Vue.use(DndsPlugin);
    
    return (model) => {
        model = model || {};
        
        new Vue({
            el: selector,
            store: store,
            render: function(createElement) {
                return createElement(rootComponent, {
                    props: model
                });
            },
            
            //https://vuejs.org/v2/guide/components-registration.html
            components: (localRegisteredComponents || []).reduce((components, component) => {
                components[component.name] = component;
                return components;
            }, {})
        });
    };
};